export default __webpack_public_path__ + "static/IBMPlexSans-Medium-1d185a0db4162183ed431049e1bfa960.woff2";